import React from 'react'
import { Route, Router, Redirect, Switch } from 'react-router-dom'
import history from './history'

import RootContainer from './RootContainer'
import Editor from './pages/Editor'
import SignIn from './pages/SignIn'
import Dashboard from './pages/Dashboard'
import Subscriptions from './pages/Subscriptions'
import Account from './pages/Account'
import FullStoryIntegration from './FullStoryIntegration'
import NotificationController from './NotificationController'
import WhimmWebSiteRunner from './pages/WhimmWebSiteRunner'
import ShopifyApp from './pages/ShopifyApp'
import ShopifyAppRunner from './pages/ShopifyAppRunner'
import ShopifyDashboard from './pages/ShopifyDashboard'
import ChargeDeclinedPage from './pages/ChargeDeclinedPage'

let routes = (
  <RootContainer>
    <Switch>
      <Redirect exact from='/' to='/dashboard' />
      <Route path={'/app/:appId'} component={Editor} />
      <Route path={'/dashboard/:tab'} component={Dashboard} />
      <Route path={'/dashboard'} component={Dashboard} />
      <Route path={'/auth'} component={SignIn} />
      <Route path={'/plan'} component={Subscriptions} />
      <Route path={'/whimm-website'} component={WhimmWebSiteRunner} />
      <Route path={'/account'} component={Account} />
      <Route path={'/shopify-app/dashboard'} component={ShopifyDashboard} />
      <Route path={'/shopify-app/charge-declined'} component={ChargeDeclinedPage} />
      <Route path={'/shopify-app/:appId'} component={ShopifyApp} />
      <Route path={'/shopify-app'} component={ShopifyAppRunner} />
    </Switch>
    <FullStoryIntegration />
    <NotificationController />
  </RootContainer>
)
// Any update within the app will bubble up to this file
// We can't create a new <Route> element though, because Router won't accept
// updates to its routes prop.
// So we're passing the previous export from update to update to prevent Router from complaining
// The React components themselves will still update properly
if (module.hot) {
  let oldRoutes = module.hot.data && module.hot.data.routes
  if (oldRoutes) {
    routes = oldRoutes
  }
  module.hot.dispose(data => {
    data.routes = routes
  })
}

const Root = () => (
  <Router history={history}>
    {routes}
  </Router>
)

export default Root



// WEBPACK FOOTER //
// ./src/components/Root.js